import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import { Datepicker } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

const className = classnames(
	'py-2 px-3 flex flex-col space-y-2 border-4 rounded-lg cursor-pointer transition-all',
	'dark:border-neutral-800 dark:bg-neutral-800 hover:dark:bg-neutral-900',
	'border-white bg-white hover:bg-neutral-50'
);

const Webinar = ({ webinar }) => {
	// Get date theme
	// const theme = useMemo(() => {
	// 	const days = Math.abs(DayJs().diff(webinar.eventAt, 'day'));
	// 	return days <= 7 ? 'informative' : '';
	// }, [webinar.eventAt]);

	return (
		<Link to={`/webinars/${webinar.id}`} className={className}>
			<Title
				title={webinar?.course?.title}
				subtitle={webinar?.subject?.title}
				className="flex-1"
			/>

			<div className="flex justify-end">
				<Datepicker
					time
					readOnly
					value={webinar.eventAt}
				/>
			</div>
		</Link>
	);
};

export default Webinar;